import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.gray[7]};
`;
